import {FC} from "react";
import ConfirmationDialog from "@/components/common/dialogs/ConfirmationDialog";

interface RemoveRecipientModalProps {
	open: boolean;
	onClose: () => void;
	onConfirm: () => void;
	recipientName: string;
}

export const RemoveRecipientModal: FC<RemoveRecipientModalProps> = ({
	open,
	onClose,
	onConfirm,
	recipientName
}) => {
	const handleConfirm = () => {
		onConfirm();
	};

	return (
		<ConfirmationDialog
			open={open}
			onClose={onClose}
			onCancel={onClose}
			onConfirm={handleConfirm}
			title="Remove Recipient"
			content={`Are you sure you want to remove ${recipientName} from the distribution list?`}
			testIdPrefix="removeRecipient"
			confirmButtonColor="error"
			maxWidth="sm"
		/>
	);
};
